import axios from "axios";

const $host = axios.create({
    baseURL:'https://aks.aps.by'
    //baseURL:'/'
})

export {
    $host,
}